import React, {useRef} from 'react';
import {CssBaseline} from "@mui/material";
import {Appbar} from "./components/Appbar";
import {Acasa} from "./components/Acasa";
import {Servicii} from "./components/Servicii";
import {Despre} from "./components/Despre";
import CompanyStats from "./components/CompanyStats";
import {Proiecte} from "./components/Proiecte";
import {Contact} from "./components/Contact";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import PaginaProiecte from './components/PaginaProiecte';
import {TermeniSiConditii} from "./components/TermeniSiConditii";
import ScrollToTop from "./components/ScrollToTop";
import SEO from './components/SEO';

const siteUrl = 'https://www.allproservice.ro';
const ogImage = `${siteUrl}/favicon.ico`;

export const App = () => {
    const acasaRef = useRef(null);
    const serviciiRef = useRef(null);
    const despreRef = useRef(null);
    const proiecteRef = useRef(null);
    const contactRef = useRef(null);

    return (
        <Router>
            <div>
                <CssBaseline/>
                <ScrollToTop />
                <Appbar refs={{ acasaRef, serviciiRef, despreRef, proiecteRef, contactRef }}/>
                <Routes>
                    <Route path="/" element={
                        <>
                            {/*<SEO*/}
                            {/*    title="Allpro Service SRL | Confecții metalice și relocări utilaje în Cluj-Napoca"*/}
                            {/*    description="Allpro Service SRL oferă confecții metalice, structuri metalice, prelucrări mecanice și relocări de echipamente în Cluj-Napoca. Contactează-ne pentru ofertă."*/}
                            {/*    canonical={`${siteUrl}/`}*/}
                            {/*    image={ogImage}*/}
                            {/*    jsonLd={[*/}
                            {/*        {*/}
                            {/*            "@context": "https://schema.org",*/}
                            {/*            "@type": "Organization",*/}
                            {/*            "name": "Allpro Service SRL",*/}
                            {/*            "url": `${siteUrl}/`,*/}
                            {/*            "logo": `${siteUrl}/favicon.ico`,*/}
                            {/*            "contactPoint": [{*/}
                            {/*                "@type": "ContactPoint",*/}
                            {/*                "telephone": "+40-744-624-840",*/}
                            {/*                "contactType": "customer service",*/}
                            {/*                "areaServed": "RO",*/}
                            {/*                "availableLanguage": ["ro", "en"]*/}
                            {/*            }],*/}
                            {/*            "address": {*/}
                            {/*                "@type": "PostalAddress",*/}
                            {/*                "streetAddress": "Strada Oașului 363",*/}
                            {/*                "addressLocality": "Cluj-Napoca",*/}
                            {/*                "postalCode": "400645",*/}
                            {/*                "addressCountry": "RO"*/}
                            {/*            }*/}
                            {/*        },*/}
                            {/*        {*/}
                            {/*            "@context": "https://schema.org",*/}
                            {/*            "@type": "WebSite",*/}
                            {/*            "name": "Allpro Service SRL",*/}
                            {/*            "url": `${siteUrl}/`,*/}
                            {/*            "potentialAction": {*/}
                            {/*                "@type": "SearchAction",*/}
                            {/*                "target": `${siteUrl}/?s={search_term_string}`,*/}
                            {/*                "query-input": "required name=search_term_string"*/}
                            {/*            }*/}
                            {/*        }*/}
                            {/*    ]}*/}
                            {/*/>*/}
                            <Acasa ref={acasaRef} toRef={serviciiRef} />
                            <Servicii ref={serviciiRef}/>
                            <Despre ref={despreRef}/>
                            {/*<CompanyStats/>*/}
                            <Proiecte ref={proiecteRef}/>
                            <Contact ref={contactRef} acasaRef={acasaRef}/>
                        </>
                    } />
                    <Route path="/pagina-proiecte" element={
                        <>
                            {/*<SEO*/}
                            {/*    title="Allpro Service SRL | Galerie proiecte"*/}
                            {/*    description="Vezi o selecție de proiecte ALLPRO Service: balustrade, garduri, copertine, structuri metalice și alte confecții metalice realizate."*/}
                            {/*    canonical={`${siteUrl}/pagina-proiecte`}*/}
                            {/*    image={ogImage}*/}
                            {/*    jsonLd={{*/}
                            {/*        "@context": "https://schema.org",*/}
                            {/*        "@type": "BreadcrumbList",*/}
                            {/*        "itemListElement": [*/}
                            {/*            {*/}
                            {/*                "@type": "ListItem",*/}
                            {/*                "position": 1,*/}
                            {/*                "name": "Acasă",*/}
                            {/*                "item": `${siteUrl}/`*/}
                            {/*            },*/}
                            {/*            {*/}
                            {/*                "@type": "ListItem",*/}
                            {/*                "position": 2,*/}
                            {/*                "name": "Proiecte",*/}
                            {/*                "item": `${siteUrl}/pagina-proiecte`*/}
                            {/*            }*/}
                            {/*        ]*/}
                            {/*    }}*/}
                            {/*/>*/}
                            <PaginaProiecte />
                        </>
                    } />
                    <Route path="/termenisiconditii" element={
                        <>
                            {/*<SEO*/}
                            {/*    title="Allpro Service SRL | Termeni și condiții"*/}
                            {/*    description="Citește termenii și condițiile de utilizare ale site-ului ALLPRO Service."*/}
                            {/*    canonical={`${siteUrl}/termenisiconditii`}*/}
                            {/*    image={ogImage}*/}
                            {/*    jsonLd={{*/}
                            {/*        "@context": "https://schema.org",*/}
                            {/*        "@type": "BreadcrumbList",*/}
                            {/*        "itemListElement": [*/}
                            {/*            {*/}
                            {/*                "@type": "ListItem",*/}
                            {/*                "position": 1,*/}
                            {/*                "name": "Acasă",*/}
                            {/*                "item": `${siteUrl}/`*/}
                            {/*            },*/}
                            {/*            {*/}
                            {/*                "@type": "ListItem",*/}
                            {/*                "position": 2,*/}
                            {/*                "name": "Termeni și condiții",*/}
                            {/*                "item": `${siteUrl}/termenisiconditii`*/}
                            {/*            }*/}
                            {/*        ]*/}
                            {/*    }}*/}
                            {/*/>*/}
                            <TermeniSiConditii />
                        </>
                    } />
                </Routes>
            </div>
        </Router>
    );
}
